
import React, { useState, useEffect, useRef } from "react";
import { useNavigate, Link, useParams } from "react-router-dom";
import axios from "axios";
import Newnavbar from "../Newnavbar.js";
import Digitlfoodsidebar from "../Digitalfood/Digitlfoodsidebar.js";
import CateringMenudata from "./CateringMenudata.js";
import menu1 from "../grocerybanner.png";
// import "../housemaamaas.css";
import "../Style.css";
import CateringSidescrollAdvertisements from './CateringSidescrollAdvertisements';
import CateringItems from "./CateringItems.js";

const CATERING_VENDOR_API = "http://10.10.20.9:7007/caterings-0.0.1-SNAPSHOT/api/banner/get";

const CateringHomemaamaas = () => { // ✅ Remove setShowLogin from props
  const [isOpen, setIsOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [coupons, setCoupons] = useState([]);
  const [bannerData, setBannerData] = useState(null);
  const [cateringPackages, setCateringPackages] = useState([]);
  const [categories, setCategories] = useState([]);
  const [activeCategory, setActiveCategory] = useState("Allitems");
  const [loading, setLoading] = useState(true);
  const scrollContainerRef = useRef(null);
  const [isHovered, setIsHovered] = useState(false);

  // ✅ ADD LOCAL STATE FOR LOGIN
  const [showLogin, setShowLogin] = useState(false);
  const [parentId, setParentId] = useState(null);

  // ✅ Get vendorId from URL
  const { vendorId } = useParams();

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const [orderType, setOrderType] = useState(null);
  const userId = localStorage.getItem("userId");

  useEffect(() => {
    const fetchOrderType = async () => {
      try {
        const res = await axios.get(
          ` https://backend.maamaas.com/food/api/cart/${userId}`
        );
        if (res.data && res.data.length > 0) {
          setOrderType(res.data[0].orderType);
        }
      } catch (err) {
        console.error("Error fetching order type:", err);
      }
    };

    if (userId) {
      fetchOrderType();
    }
  }, [userId]);

  // ✅ FETCH SPECIFIC VENDOR DATA USING vendorId FROM URL
  useEffect(() => {
    const fetchVendorData = async () => {
      try {
        const token = localStorage.getItem("authToken");

        const res = await axios.get(
          `${CATERING_VENDOR_API}/${vendorId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (res.data) {
          setBannerData({
            ...res.data,
            companyLogo: toImageSrc(res.data.companyLogo),
            companyName: res.data.companyName,
          });
        }
      } catch (err) {
        console.error("❌ Failed to fetch catering vendor:", err);
      }
    };

    if (vendorId) {
      fetchVendorData();
    }
  }, [vendorId]);

  // ✅ FETCH CATERING PACKAGES
  useEffect(() => {
    const fetchCateringPackages = async () => {
      if (!vendorId) {
        setLoading(false);
        return;
      }

      try {
        const token = localStorage.getItem("authToken");
        setLoading(true);

        const response = await fetch(
          `http://10.10.20.9:7007/caterings-0.0.1-SNAPSHOT/api/package/${vendorId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              Accept: "application/json",
            },
          }
        );

        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        const data = await response.json();

        console.log("Catering API Response:", data);

        const packages = Array.isArray(data) ? data : [];

        if (packages.length === 0) {
          console.log("No packages found");
          setCateringPackages([]);
          setCategories([]);
          setLoading(false);
          return;
        }

        // Extract unique package types as categories
        const uniqueTypes = [...new Set(packages.map(item => item.packageType))].filter(Boolean);

        const cats = uniqueTypes.map((type, index) => ({
          id: index + 1,
          name: type,
          packageType: type
        }));

        console.log("📂 Categories found:", cats);
        console.log("📦 Packages found:", packages.length);

        setCategories(cats);
        setCateringPackages(packages);
        setLoading(false);
      } catch (err) {
        console.error("❌ Error fetching catering data:", err);
        setCateringPackages([]);
        setCategories([]);
        setLoading(false);
      }
    };

    if (vendorId) {
      fetchCateringPackages();
    }
  }, [vendorId]);

  const toImageSrc = (raw) => {
    if (!raw || raw.trim() === "/") return "/placeholder.svg";
    if (raw.startsWith("data:image")) return raw;
    if (/^https?:\/\//i.test(raw)) return raw;
    if (raw.length > 100) return `data:image/jpeg;base64,${raw}`;
    return "/placeholder.svg";
  };

  // ✅ Handle category click for filtering
  const handleCategoryClick = (categoryName) => {
    console.log("Category clicked:", categoryName);

    if (categoryName === "Allitems") {
      setParentId(null);
      setActiveCategory("Allitems");
      return;
    }

    const selected = categories.find(
      (cat) =>
        cat.name.trim().toLowerCase() ===
        categoryName.trim().toLowerCase()
    );

    if (selected) {
      setParentId(selected.id);
      setActiveCategory(categoryName);
    } else {
      setParentId(null);
      setActiveCategory("Allitems");
    }
  };

  // ✅ Sidebar Items - Updated to show current page
  const sidebarItems = [
    {
      label: bannerData?.companyName || "Catering Service",
      link: `/cateringHomemaamaas/${vendorId}`,
      img: bannerData?.companyLogo || "/placeholder.png",
    }
  ];

  if (loading) {
    return (
      <div>
        <Newnavbar />
        <Digitlfoodsidebar />
        <div className="container-fluid" style={{ marginTop: "100px", textAlign: "center" }}>
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
          <p style={{ marginTop: "20px" }}>Loading catering packages...</p>
        </div>
      </div>
    );
  }

  return (
    <div>
      <Newnavbar />
      <Digitlfoodsidebar />

      {/* ✅ ADD LOGIN MODAL IF NEEDED */}
      {showLogin && (
        <div style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: "rgba(0,0,0,0.5)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 9999
        }}>
          <div style={{
            background: "white",
            padding: "30px",
            borderRadius: "10px",
            textAlign: "center"
          }}>
            <h3>Login Required</h3>
            <p>Please login to add items to cart</p>
            <button
              onClick={() => setShowLogin(false)}
              style={{
                background: "#ee6521",
                color: "white",
                border: "none",
                padding: "10px 20px",
                borderRadius: "5px",
                cursor: "pointer"
              }}
            >
              Close
            </button>
          </div>
        </div>
      )}

      <div className="container-fluid">
        <div className="row ms-0">
          {/* LEFT SIDEBAR */}
          <div className="col-lg-2 col-12 maamaas-home-data-top">
            {isMobile ? (
              <div className="d-flex flex-column align-items-start">
                {/* First item */}
                <div
                  className="d-flex align-items-center p-2 w-100"
                  style={{
                    background: "#fff",
                    border: "1px solid #ccc",
                    marginTop: "130px",
                    borderRadius: "8px",
                    marginBottom: "10px",
                  }}
                >
                  <img
                    src={sidebarItems[0].img}
                    alt={sidebarItems[0].label}
                    style={{
                      width: "40px",
                      height: "40px",
                      borderRadius: "50%",
                      marginRight: "10px",
                      objectFit: "cover",
                    }}
                  />
                  <Link
                    to={sidebarItems[0].link}
                    style={{
                      fontWeight: "bold",
                      color: "#333",
                      textDecoration: "none",
                    }}
                  >
                    {sidebarItems[0].label}
                  </Link>
                </div>

                {/* Dropdown */}
                {/* <button
                  className="btn btn-primary w-100"
                  onClick={() => setIsOpen(!isOpen)}
                >
                  {isOpen ? "Hide More ▲" : "Show More ▼"}
                </button> */}

                {isOpen && (
                  <div
                    className="d-flex flex-column mt-2 p-2 w-100"
                    style={{
                      background: "#fff",
                      border: "1px solid #ccc",
                      borderRadius: "8px",
                    }}
                  >
                    {sidebarItems.slice(1).map((item, i) => (
                      <a
                        key={i}
                        href={item.link}
                        className="d-flex align-items-center p-2"
                        style={{
                          textDecoration: "none",
                          borderBottom:
                            i !== sidebarItems.slice(1).length - 1
                              ? "1px solid #eee"
                              : "none",
                        }}
                      >
                        <img
                          src={item.img}
                          alt={item.label}
                          style={{
                            width: "40px",
                            height: "40px",
                            borderRadius: "50%",
                            marginRight: "10px",
                            objectFit: "cover",
                          }}
                        />
                        <span style={{ fontWeight: "bold", color: "#333" }}>
                          {item.label}
                        </span>
                      </a>
                    ))}
                  </div>
                )}
              </div>
            ) : (
              <div className="row gx-0 ms-0">
                {sidebarItems.map((item, i) => (
                  <div
                    key={i}
                    className="card d-flex justify-content-center align-items-center text-center"
                    style={{
                      position: "fixed",
                      width: "180px",
                      height: "180px",
                      backgroundColor: "rgba(217, 217, 217, 1)",
                      marginBottom: "20px",
                      overflow: "hidden",
                    }}
                  >
                    <img
                      src={item.img}
                      alt={item.label}
                      style={{
                        borderRadius: "50%",
                        width: "130px",
                        height: "130px",
                        objectFit: "cover",
                        objectPosition: "center",
                      }}
                    />
                    <a
                      href={item.link}
                      className="btn mt-2"
                      style={{ backgroundColor: "#fff", fontWeight: "bold" }}
                    >
                      {item.label}
                    </a>
                  </div>
                ))}
              </div>
            )}
          </div>

          {/* CENTER CONTENT - UPDATED */}
          <div className="col-lg-8 col-md-12 col-sm-12 col-12">
            {/* Breadcrumbs */}
            {/* Breadcrumbs */}
            {bannerData && (
              <div
  style={{
    position: isMobile ? "relative" : "fixed",
    top: isMobile ? "0px" : "63px",
    left: 0,
    width: "100%",
    background: "#fff",
    zIndex: 1000,
    padding: isMobile ? "10px 0" : "12px 0",
    borderBottom: "1px solid #eee",
  }}
>
  <p
    className="maamaas-home-bredcumsyy"
    style={{
      marginLeft: isMobile ? "15px" : "276px", // TEXT left offset
      marginTop: 0,
      marginBottom: 0,
      fontSize: isMobile ? "14px" : "18px",
    }}
  >
    <Link
      to="/"
      style={{
        color: "#ee6521",
        fontWeight: "bold",
        textDecoration: "none",
        fontSize: isMobile ? "14px" : "inherit",
      }}
    >
      Home
    </Link>

    <span className="separator"> &gt; </span>

    <span
      style={{
        color: "#ee6521",
        fontWeight: "bold",
        fontSize: isMobile ? "14px" : "inherit",
      }}
    >
      {bannerData?.companyName || "Catering Service"}
    </span>
  </p>
</div>

            )}

            {/* Banner Section */}
            <div style={{ marginBottom: "30px" }}>
              <CateringMenudata vendorId={vendorId} />
            </div>

            {/* Catering Packages Section - RIGHT BELOW BANNER */}
            <div id="packages" style={{
              marginTop: "100px",
              padding: "0 15px",
            }}>
              {/* Category Filter for Mobile */}
              {isMobile && (
                <div style={{ marginBottom: "20px" }}>
                  <select
                    onChange={(e) => handleCategoryClick(e.target.value)}
                    value={activeCategory}
                    style={{
                      width: "100%",
                      padding: "12px",
                      borderRadius: "10px",
                      background: "rgb(177 93 198)",
                      color: "#fff",
                      fontWeight: "bold",
                      border: "none",
                      outline: "none",
                      fontSize: "16px"
                    }}
                  >
                    <option value="Allitems">All Packages</option>
                    {categories.map((cat) => (
                      <option key={cat.id} value={cat.name}>
                        {cat.name}
                      </option>
                    ))}
                  </select>
                </div>
              )}

              {/* Category Filter for Desktop */}
              {!isMobile && categories.length > 0 && (
                <div style={{
                  marginBottom: "25px",
                  display: "flex",
                  gap: "10px",
                  flexWrap: "wrap"
                }}>


                </div>
              )}

              {/* ✅ Catering Items - NOW WITH WORKING setShowLogin */}
              <CateringItems
                parentId={parentId}
                setShowLogin={setShowLogin} // ✅ Now this is a real function
                categories={categories}
                cateringPackages={cateringPackages}
                activeCategory={activeCategory}
              />
            </div>
          </div>

          {/* RIGHT COUPONS */}
          <div
            className="col-lg-3"
            style={{ display: isMobile ? "none" : "block" }}
          >
            <CateringSidescrollAdvertisements />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CateringHomemaamaas;